import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

export function MSALInstanceFactory(router: Router): IPublicClientApplication {
    const instance = new PublicClientApplication({
        auth: {
            clientId: environment.msalConfig.auth.clientId,
            authority: environment.msalConfig.auth.authority,
            knownAuthorities: [environment.msalConfig.auth.authorityDomain],
            redirectUri: environment.msalConfig.auth.redirectUri,
            postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: true
        },
        system: {
            allowNativeBroker: false,
            loggerOptions: {
                loggerCallback,
                logLevel: LogLevel.Verbose,
                piiLoggingEnabled: true
            }
        }
    });

    instance.addEventCallback((event) => {
        if (event.eventType === "msal:loginSuccess" || event.eventType === "msal:acquireTokenSuccess") {
            const account = instance.getAllAccounts()[0];

            if (account) {
                const idTokenClaims = account.idTokenClaims as any;
                const claimReference = idTokenClaims["extension_CaseReference"];

                if (claimReference) {
                    const currentRoute = router.url;
                    const excludedRoutes = ['/form', '/scripting', '/summary', `/home/${claimReference}`];
                    const isExcludedRoute = excludedRoutes.some(route => currentRoute.startsWith(route));

                    if (!isExcludedRoute) {
                        const redirectUri = `/home/${claimReference}`;
                        router.navigateByUrl(redirectUri);
                    }
                }
            }
        }
    });

    return instance;
}

function loggerCallback(logLevel: LogLevel, message: string): void {
   // console.log(message);
}
